import { useState } from 'react'
import { img } from '../assets/assets'
import { Popup } from '../hoc/Popup'
// import { loginAsMetamask } from '../utils/wallet/auth'
import {
    loginAsMetamask,
    // loginAsWalletConnect,
    // reloadWalletConnect,
} from '../utils/wallet/auth'
import { Button } from './UI/Buttons'

export const Metamask = () => {
    const [show, setShow] = useState(false)
    return (
        <>
            <Button
                className="header__connect"
                size="large"
                onClick={() => setShow(true)}
                rounded
            >
                Connect wallet
            </Button>

            <Popup showState={[show, setShow]} title="Connect your wallet">
                <div className="popup-auth">
                    <div className="popup-auth__row">
                        <Button
                            icon={<img src={img.metamaskLogo} alt=""></img>}
                            onClick={loginAsMetamask}
                            className="popup-auth__item"
                        >
                            Metamask
                        </Button>
                    </div>
                    {/* <div className="popup-auth__row">
                        <Button
                            className="popup-auth__item"
                            icon={
                                <img src={img.walletConnectLogo} alt=""></img>
                            }
                            onClick={loginAsWalletConnect}
                        >
                            Wallet Connect
                        </Button>
                        <div className="popup-auth__smallitem">
                            <Button onClick={reloadWalletConnect} size="small">
                                <i className="fas fa-sync-alt"></i>
                            </Button>
                        </div>
                    </div> */}
                </div>
            </Popup>
        </>
    )
}
